// ======================================================================
// File Name       : LivePerformanceSearchForm
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, FormControl, Col, InputGroup, Button } from 'react-bootstrap';
import Datetime from 'react-datetime';
import SelectBox from '../../components/SelectBox';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import { DATA_AFFIILIATION_TYPE_STR } from '../../constants/ContentConstant';
import { onChangeWrapper } from '../../utils/FormUtils';
import { VALIDATE_TYPE } from '../../constants/index';
import FormControlValidate from '../FormControlValidate';
import RenderField from '../../utils/ReduxFormUtils';
import PaginationCustom from '../Pagination';
import ReduxFormPaging from '../ReduxFormPaging';
import { USER_ATTRIBUTE_KEY_NUM_LIST } from '../../constants/UserAttributeConstants';
import CustomButton from '../button/CustomButton';

class LivePerformanceSearchForm extends React.Component {
  render() {
    const {
    liveList,
    onSearchBtnClick,
    liveName,
    organizerUserName,
    userAttributeKeyNum,
    startPosition,
    userAttributeSearchText,
    } = this.props;

    return (
      <div>
        <h3>検索する項目を指定してください</h3>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            onSearchBtnClick();
          }}
          className='form-horizontal'
        >
          <Col sm={12} className="padding-top-10">
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                  ライブ名
              </Col>
              <Col sm={9}>
                <RenderField type="text" name="liveName" label="ライブ名" value={liveName} />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                ライブ開催者名
              </Col>
              <Col sm={9}>
                <RenderField type="text" name="organizerUserName" label="ライブ開催者名" value={organizerUserName} />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                自由記述領域
              </Col>
              <Col sm={2}>
                <RenderField
                  type="selectbox"
                  name="userAttributeKeyNum"
                  label="ライブ開催者名"
                  value={userAttributeKeyNum}
                  data={USER_ATTRIBUTE_KEY_NUM_LIST}
                  normalizeSelectBox
                />
              </Col>
              <Col sm={7}>
                <RenderField type="text" name="userAttributeSearchText" label="自由記述領域" value={userAttributeSearchText} />
              </Col>

            </Form.Group>
            <Form.Group className="form-info">
              <Col sm={3} as={Form.Label}>
                実施日時
              </Col>
              <Col sm={3}>
                <RenderField
                  type="datetime"
                  name="liveStartFrom"
                  validates={[VALIDATE_TYPE.DATE_TIME]}
                  normalizeDateTime
                />
              </Col>
              <Col sm={1} className="text-center " as={Form.Label}>
                ～
              </Col>
              <Col sm={3}>
                <RenderField
                  type="datetime"
                  name="liveStartTo"
                  validates={[VALIDATE_TYPE.DATE_TIME]}
                  normalizeDateTime
                />
              </Col>
            </Form.Group>
            <Col sm={12}>
              <RenderField
                name="dateTimeMinMax"
                type="dateTimeMinMax"
                validates={[VALIDATE_TYPE.DATE_TIME_MIN_MAX]}
                keyDateFrom={'liveStartFrom'}
                keyDateTo={'liveStartTo'}
              />
            </Col>
          </Col>
          <Form.Group className="text-center">
            <Col sm={12}>
              <CustomButton
                btnStyle="btn btn-primary btn-96 margin-top-20"
                type="submit"
                text="検索"
                iconClass="bi bi-search"
              />
            </Col>
          </Form.Group>
        </Form>
      </div>
    );
  }
}

export default LivePerformanceSearchForm;
